<template>
  <CardWrapper :loading="!article" class="card-3">
    <template v-if="article">
      <InputWithEdit
        v-model="article.apc"
        class="apc"
        title="Edit APC"
        @update="$emit('update-apc', arguments[0], arguments[1])"
      />

      <h6>APC</h6>

      <InputWithEdit
        v-model="article.other_charges"
        class="other-charges"
        title="Edit other charges"
        @update="$emit('update-other-charges', arguments[0], arguments[1])"
      />

      <div class="text-subtitle1 q-ma-xs">Other Charges</div>
    </template>
  </CardWrapper>
</template>

<script>
// Components
import CardWrapper from '../../CardWrapper'
import InputWithEdit from './InputWithEdit'

export default {
  components: {
    CardWrapper,
    InputWithEdit
  },

  props: {
    article: Object
  }
}
</script>

<style lang="stylus" scoped>
.card-3 {
  background-color #346182
  color white
  text-align center

  >>> .apc {
    font-size 2rem
    font-weight 800

    > small {
      font-weight 400
    }
  }

  >>> .other-charges {
    font-size 1.5rem
    font-weight 800

    > small {
      font-size 65%
      font-weight 400
    }
  }
}
</style>
